module.exports = __webpack_public_path__ + "img/p_normalB@2x.1ed7496b.png";